import { BeBox, BeGrid, BePage, BeStack } from "@beos-css/react/index.ts";

export function TilesDemo() {
	const items = ["Metrics", "Aging", "Priorities", "Statuses", "Throughput", "Cycle time", "Blocked"];
	return (
		<section id="demo-page-tiles">
			<h2>Tiling grid (BeGrid)</h2>
			<p>
				The other grid, and the one to reach for when items should <em>keep their size</em> rather than share the row. <code>min</code> is a
				count of page units — <code>min=&#123;14&#125;</code> is 224px — and the column count is whatever fits, so narrowing the window
				drops one tile per line instead of narrowing all of them. No threshold is involved, which is the difference from <code>BeCols</code>
				: a <code>span</code> is a fraction of sixteen and every row stacks at once.
			</p>
			<BePage className="be-panel" pad={1}>
				<BeStack gap="section">
					<BeGrid min={14} gap="item">
						{items.map((t) => (
							<BeBox key={t} border="plain">
								{t}
							</BeBox>
						))}
					</BeGrid>
					{/* `rigid` leaves a hole rather than growing the survivors, which is what makes default tracks fractional. */}
					<BeGrid min={14} gap="item" rigid>
						{items.map((t) => (
							<BeBox key={t} border="plain">
								{t} (rigid)
							</BeBox>
						))}
					</BeGrid>
					{/* `.is-full` is BeGrid's only break-out (spans belong to BeCols), and has no prop yet. */}
					<BeGrid min={14} gap="item">
						<BeBox border="plain">{items[0]}</BeBox>
						<BeBox border="plain">{items[1]}</BeBox>
						<BeBox className="is-full" border="plain">
							Summary — is-full, takes the whole row
						</BeBox>
						{items.slice(2).map((t) => (
							<BeBox key={t} border="plain">
								{t}
							</BeBox>
						))}
					</BeGrid>
				</BeStack>
			</BePage>
		</section>
	);
}
